import "./footer.css";

export const Footer = () => {
  const currentYear = new Date();

  return (
    <footer className="footer">
      <div className="copyright">
        <p className="copy">&copy;{currentYear.getFullYear()}</p>
        <p>by Joseph Matheus</p>
        <p>All rights reserved</p>
      </div>
      <div className="personalInfo">
        <div className="mail">
          <h3>Email</h3>
          <p>josephmatheus@hotmail.com</p>
        </div>
        <div className="phone">
          <h3>Telefone</h3>
          <p>(81) 98696 - 1323</p>
        </div>
        <div className="socialMedia">
          <h3>Redes sociais</h3>
          <ul>
            <li>
              <a
                className="linkedin"
                href="https://linkedin.com/in/josephmatheus"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </li>
            <li>
              <a
                className="github"
                href="https://github.com/josephmatheus"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-github"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
